import * as React from 'react';
import { useModalStore } from '@Stores';

import ModalSkeleton from './Components/ModalSkeleton/ModalSkeleton';


export const ModalContainer: React.FC = () => {
    const modalData = useModalStore(state => state.modalData);

    const getModalZIndex = (modalIndex: number) => 1050 + modalIndex * 50;

    const modals = React.useMemo(() => {
        return modalData.map((modal, index) => {
            const props = modal.props as React.Attributes;
            const element = React.createElement(modal.dialog, props);

            return (
                <div key={index} style={{ zIndex: getModalZIndex(index), position: 'fixed' }}>
                    <React.Suspense fallback={<ModalSkeleton {...props} />}>
                        {element}
                    </React.Suspense>
                </div>
            );
        });
    }, [modalData]);

    return (
        <>
            {modals}
        </>
    );
}
